// // global product sku num 
const selectElement = document.querySelector('#pincode-btn');
const dataSkuValue = selectElement.dataset.sku;
const iconRefresh = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="16" viewBox="0 0 24 24" style="fill: rgba(0, 0, 0, 1);transform: ;msFilter:;"><path d="M10 11H7.101l.001-.009a4.956 4.956 0 0 1 .752-1.787 5.054 5.054 0 0 1 2.2-1.811c.302-.128.617-.226.938-.291a5.078 5.078 0 0 1 2.018 0 4.978 4.978 0 0 1 2.525 1.361l1.416-1.412a7.036 7.036 0 0 0-2.224-1.501 6.921 6.921 0 0 0-1.315-.408 7.079 7.079 0 0 0-2.819 0 6.94 6.94 0 0 0-1.316.409 7.04 7.04 0 0 0-3.08 2.534 6.978 6.978 0 0 0-1.054 2.505c-.028.135-.043.273-.063.41H2l4 4 4-4zm4 2h2.899l-.001.008a4.976 4.976 0 0 1-2.103 3.138 4.943 4.943 0 0 1-1.787.752 5.073 5.073 0 0 1-2.017 0 4.956 4.956 0 0 1-1.787-.752 5.072 5.072 0 0 1-.74-.61L7.05 16.95a7.032 7.032 0 0 0 2.225 1.5c.424.18.867.317 1.315.408a7.07 7.07 0 0 0 2.818 0 7.031 7.031 0 0 0 4.395-2.945 6.974 6.974 0 0 0 1.053-2.503c.027-.135.043-.273.063-.41H22l-4-4-4 4z"></path></svg>';
const iconCheck = '<svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="7.5" cy="7.5" r="7.5" fill="#1C1C1C"/><path d="M3.48047 7.71062L5.41145 10.3094L11.6321 5.0918" stroke="#FCFCFC" stroke-width="1.6"/></svg>';
const iconDelivery= '<svg width="15" height="15" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="8" cy="8" r="8" fill="#1C1C1C"/><path d="M9.66667 4.8H10.0167H9.66667ZM9.66667 10.8571V11.2071H9.66667L9.66667 10.8571ZM3.71429 10.5071C3.52099 10.5071 3.36429 10.6638 3.36429 10.8571C3.36429 11.0504 3.52099 11.2071 3.71429 11.2071V10.5071ZM4.42857 3.65C4.23527 3.65 4.07857 3.8067 4.07857 4C4.07857 4.1933 4.23527 4.35 4.42857 4.35V3.65ZM8.83333 4V3.65V4ZM9.66667 5.52857H10.0167H9.66667ZM13 7.48181H13.35V7.48181L13 7.48181ZM13 10.4H12.65H13ZM12.5238 10.8571V10.5071V10.8571ZM10.1429 5.07143V5.42143V5.07143ZM11.3108 5.07143V4.72143V5.07143ZM11.7119 5.28215L11.4207 5.47629L11.7119 5.28215ZM12.8498 6.98896L13.141 6.79481L12.8498 6.98896ZM3.71443 5.25C3.52113 5.25 3.36443 5.4067 3.36443 5.6C3.36443 5.7933 3.52113 5.95 3.71443 5.95V5.25ZM7.28584 5.95C7.47914 5.95 7.63584 5.7933 7.63584 5.6C7.63584 5.4067 7.47914 5.25 7.28584 5.25V5.95ZM3 7.07857C2.8067 7.07857 2.65 7.23527 2.65 7.42857C2.65 7.62187 2.8067 7.77857 3 7.77857V7.07857ZM6.09523 7.77857C6.28853 7.77857 6.44523 7.62187 6.44523 7.42857C6.44523 7.23527 6.28853 7.07857 6.09523 7.07857V7.77857ZM3.23823 8.90714C3.04494 8.90714 2.88823 9.06384 2.88823 9.25714C2.88823 9.45044 3.04494 9.60714 3.23823 9.60714V8.90714ZM6.85714 9.60714C7.05044 9.60714 7.20714 9.45044 7.20714 9.25714C7.20714 9.06384 7.05044 8.90714 6.85714 8.90714V9.60714ZM9.31667 4.8V10.8571H10.0167V4.8H9.31667ZM9.66667 10.5071H3.71429V11.2071H9.66667V10.5071ZM4.42857 4.35L8.83333 4.35V3.65L4.42857 3.65V4.35ZM10.0167 4.8C10.0167 4.15154 9.47327 3.65 8.83333 3.65V4.35C9.11387 4.35 9.31667 4.5648 9.31667 4.8H10.0167ZM10.0167 10.8571L10.0167 5.52857H9.31667L9.31667 10.8571H10.0167ZM12.65 7.48181V10.4H13.35V7.48181H12.65ZM12.5238 10.5071L9.66667 10.5071L9.66667 11.2071L12.5238 11.2071V10.5071ZM10.1429 5.42143H11.3108V4.72143H10.1429V5.42143ZM11.4207 5.47629L12.5586 7.1831L13.141 6.79481L12.0031 5.088L11.4207 5.47629ZM11.3108 5.42143C11.3603 5.42143 11.4003 5.44572 11.4207 5.47629L12.0031 5.088C11.8485 4.85599 11.5861 4.72143 11.3108 4.72143V5.42143ZM13.35 7.48181C13.35 7.23712 13.2769 6.99869 13.141 6.79481L12.5586 7.1831C12.6188 7.2735 12.65 7.37712 12.65 7.48181L13.35 7.48181ZM10.0167 5.52857C10.0167 5.48273 10.0596 5.42143 10.1429 5.42143L10.1429 4.72143C9.70017 4.72143 9.31667 5.06947 9.31667 5.52857H10.0167ZM12.65 10.4C12.65 10.4458 12.6071 10.5071 12.5238 10.5071V11.2071C12.9665 11.2071 13.35 10.8591 13.35 10.4H12.65ZM13 6.85H9.66667V7.55H13V6.85ZM11.4524 11.2071C11.6014 11.2071 11.6976 11.3196 11.6976 11.4286H12.3976C12.3976 10.9064 11.9608 10.5071 11.4524 10.5071V11.2071ZM11.6976 11.4286C11.6976 11.5375 11.6014 11.65 11.4524 11.65V12.35C11.9608 12.35 12.3976 11.9508 12.3976 11.4286H11.6976ZM11.4524 11.65C11.3033 11.65 11.2071 11.5375 11.2071 11.4286H10.5071C10.5071 11.9508 10.9439 12.35 11.4524 12.35V11.65ZM11.2071 11.4286C11.2071 11.3196 11.3033 11.2071 11.4524 11.2071V10.5071C10.9439 10.5071 10.5071 10.9064 10.5071 11.4286H11.2071ZM5.02381 11.2071C5.17285 11.2071 5.26905 11.3196 5.26905 11.4286H5.96905C5.96905 10.9064 5.53225 10.5071 5.02381 10.5071V11.2071ZM5.26905 11.4286C5.26905 11.5375 5.17285 11.65 5.02381 11.65V12.35C5.53225 12.35 5.96905 11.9508 5.96905 11.4286H5.26905ZM5.02381 11.65C4.87477 11.65 4.77857 11.5375 4.77857 11.4286H4.07857C4.07857 11.9508 4.51537 12.35 5.02381 12.35V11.65ZM4.77857 11.4286C4.77857 11.3196 4.87477 11.2071 5.02381 11.2071V10.5071C4.51537 10.5071 4.07857 10.9064 4.07857 11.4286H4.77857ZM3.71443 5.95H7.28584V5.25H3.71443V5.95ZM3 7.77857H6.09523V7.07857H3V7.77857ZM3.23823 9.60714H6.85714V8.90714H3.23823V9.60714Z" fill="#FCFCFC"/></svg>';
const iconCross = '<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" style="fill: rgba(0, 0, 0, 1);transform: ;msFilter:;"><path d="m16.192 6.344-4.243 4.242-4.242-4.242-1.414 1.414L10.535 12l-4.242 4.242 1.414 1.414 4.242-4.242 4.243 4.242 1.414-1.414L13.364 12l4.242-4.242z"></path></svg>';

let product_sku_num = dataSkuValue; // updating the product sku num

// setting the cookie
function setCookie(cookie_name, cookie_value, expiry_days) {
  var d = new Date();
  d.setTime(d.getTime() + (expiry_days * 24 * 60 * 60 * 1000));
  var expires = "expires=" + d.toUTCString();
  document.cookie = cookie_name + "=" + cookie_value + ";" + expires + ";path=/";
}

// run while the page loads
document.addEventListener("DOMContentLoaded", function() {
  // get cookie value
  function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  // check if the cookie set or not
  function checkCookie() {
    var pincode = getCookie("pincode");
    if (pincode != "") {
      console.log(pincode)
      displayInformation(pincode);
    }
  }

  // function called if there is any cookie present
  function displayInformation(pincode_num) {
    var new_text;
    const userAction = async () => {
      const monthNames = ["January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
      ];
      const response = await fetch(`https://5u4u6qkui8.execute-api.ap-south-1.amazonaws.com/Staging/delivery-estimate/chumbak?pincode=${pincode_num}&product_sku=${product_sku_num}`, {
        method: 'GET'
      });
      const myJson = await response.json();
      var month = new Date(myJson.estimated_delivery).getMonth();
      var only_date = new Date(myJson.estimated_delivery).getDate();
      var deliveryText = "Delivery available for " + myJson.city + ", " + myJson.state ;
      var estimated_text = "Estimated delivery by " + only_date + " " + monthNames[month];
      var errorMsg = myJson.message;

      if(myJson.status!==200){
        var mssgTxt = "Sorry, we do not deliver at this location";
        new_text = `<div> <div class="info-text"> ${errorMsg} </div></div>`;
        // Hide same-day text when pincode is not serviceable
        document.getElementById('same-day-text').style.display = 'none';
      }else if(myJson.delivery_available && myJson.status==200 && myJson.estimated_delivery && !myJson.cod_available){
        var cod_text = "Cash on Delivery is not available"
        new_text = `<div>  <div class="info-text">${iconDelivery} <span>${estimated_text}</span> </div>  <div class="info-text">${iconCheck} <span>${deliveryText}</span><span  ><div class="info-text"> </div> </span> </div></div>`;
        // Show same-day text when pincode is serviceable
        document.getElementById('same-day-text').style.display = 'block';
      }else if(myJson.delivery_available && myJson.status==200 && myJson.estimated_delivery && myJson.cod_available){
        var cod_text = "Cash on Delivery is available"
        new_text = `<div> <div class="info-text">${iconDelivery} <span>${estimated_text}</span> </div> <div class="info-text">${iconCheck} <span>${deliveryText}</span></div> <div class="info-text">${iconCheck} <span>${cod_text}</span> </div> </div>`;
        // Show same-day text when pincode is serviceable
        document.getElementById('same-day-text').style.display = 'block';
      }
    }
    userAction().then(() => {
      document.getElementById("div-text").innerHTML = new_text;
      document.querySelector('.pincode-custom-text').style.display = "none";
      document.querySelector('#pincode-input').value = pincode_num;
    });
  }

  checkCookie();

  $(".Popover__Value").click(function() {
    setTimeout(handleChange, 500);
  });

  // function called after selecting any option
  function handleChange() {
    const selectElement = document.querySelector('#pincode-btn');
    const dataSkuValue = selectElement.dataset.sku;
    product_sku_num = dataSkuValue; // updating the product sku num
    checkCookie();
  }
});

var new_text;
const userAction = async () => {
  var pincode_num = document.getElementById("pincode-input").value;
  setCookie("pincode", pincode_num, 7);
  const monthNames = ["January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ];
  const response = await fetch(`https://5u4u6qkui8.execute-api.ap-south-1.amazonaws.com/Staging/delivery-estimate/chumbak?pincode=${pincode_num}&product_sku=${product_sku_num}`, {
    method: 'GET',
  });
  const myJson = await response.json();
  var month = new Date(myJson.estimated_delivery).getMonth();
  var only_date = new Date(myJson.estimated_delivery).getDate();
  var deliveryText = "Delivery available for " + myJson.city + ", " + myJson.state ;
  var estimated_text = "Estimated delivery by " + only_date + " " + monthNames[month];
  var errorMsg = myJson.message;

  if(myJson.status!==200){
    var mssgTxt = "Sorry, we do not deliver at this location";
    new_text = `<div> <div class="info-text"> ${errorMsg} </div></div>`;
    // Hide same-day text when pincode is not serviceable
    document.getElementById('same-day-text').style.display = 'none';
  }else if(myJson.delivery_available && myJson.status==200 && myJson.estimated_delivery && !myJson.cod_available){
    var cod_text = "Cash on Delivery is not available"
    new_text = `<div>  <div class="info-text">${iconDelivery} <span>${estimated_text}</span> </div>  <div class="info-text">${iconCheck} <span>${deliveryText}</span></div></div>`;
    // Show same-day text when pincode is serviceable
    document.getElementById('same-day-text').style.display = 'block';
  }else if(myJson.delivery_available && myJson.status==200 && myJson.estimated_delivery && myJson.cod_available){
    var cod_text = "Cash on Delivery is available"
    new_text = `<div> <div class="info-text">${iconDelivery} <span>${estimated_text}</span> </div> <div class="info-text">${iconCheck} <span>${deliveryText}</span> <span  ><div class="info-text"> </div> </span> </div> <div class="info-text">${iconCheck} <span>${cod_text}</span> </div> </div>`;
    // Show same-day text when pincode is serviceable
    document.getElementById('same-day-text').style.display = 'block';
  }
}
const ele = document.getElementById("pincode-btn");
ele.addEventListener("click", clickSubmitBtn);

// This method is called when the user clicks the submit button.
function clickSubmitBtn() {
  userAction().then(() => {
    document.getElementById("div-text").innerHTML = new_text;
    document.querySelector('.pincode-custom-text').style.display = "none";
  });
}

document.addEventListener("DOMContentLoaded", function() {
  const submitButton = document.getElementById('pincode-btn');
  submitButton.addEventListener('click', clickSubmitBtn);

  const pincodeInput = document.getElementById('pincode-input');
  pincodeInput.addEventListener('keypress', function(event) {
    if (event.key === 'Enter') {
      event.preventDefault(); // Prevent the default Enter key behavior
      submitButton.click();   // Simulate a click on the submit button
    }
  });
});

function limitPincodeLength(input, maxLength) {
  if (input.value.length > maxLength) {
    input.value = input.value.slice(0, maxLength);
  }
}